/* eslint-disable i18next/no-literal-string --
   Placeholder de diagnóstico do F3: existe só para provar que a guarda deixou
   passar e que os claims chegaram. Sai inteiro no F4, quando o AppShell real
   assumir a rota `/`. Traduzir rótulos técnicos (tenant_id, Roles) seria ruído. */
import { createFileRoute } from '@tanstack/react-router'

import { useAuthStore } from '@/shared/auth/auth-store'

export const Route = createFileRoute('/_authed/')({
  component: Home,
})

/** Placeholder até o AppShell da F4. Prova que a guarda deixou passar. */
function Home() {
  const { name, email, tenantId, roles } = useAuthStore()
  return (
    <div className="bg-canvas min-h-dvh p-8">
      <div className="mx-auto flex max-w-xl flex-col gap-2 text-sm">
        <h1 className="text-ink text-xl font-semibold">Liberty Finance</h1>
        <dl className="text-ink-muted grid grid-cols-[7rem_1fr] gap-1">
          <dt>Usuário</dt>
          <dd className="text-ink">{name ?? email ?? '—'}</dd>
          <dt>tenant_id</dt>
          <dd className="text-ink font-mono text-xs">{tenantId ?? '—'}</dd>
          <dt>Roles</dt>
          <dd className="text-ink">{roles.length > 0 ? roles.join(', ') : '—'}</dd>
        </dl>
      </div>
    </div>
  )
}
